const cloudProvidersData = require('../../support/cloud_providers.json');
export function getCloudProviders() {
    return cloudProvidersData;
}
